import { Popup, PopupProps } from 'lib/classes/popup';
import { getLocaleString } from 'lib/localization/vendor';

import parse from 'html-react-parser';

const DisclaimerPopup = new Popup({
	title: () => '',
	style: {maxWidth: 600},
	distinct: true,
	closeable: false,
	render: function() {
		const mapConfig:any = this.get('map-config');
		const disclaimer:string = mapConfig.disclaimer;
		
		const drawAgreeButton = () => (
			<button style={{width: '100%'}} onClick={() => _ui.closePopupOf(this)}>
				{getLocaleString("agree")}
			</button>
		)
		
		return (
			<>
				{parse(disclaimer)}
				
				<hr />
				
				{drawAgreeButton()}
			</>
		)
	}
});

export default DisclaimerPopup;